import React from "react";
import './about.css'

function About() {
  return (
    <div className="about">
      <h1 style={{fontSize:"3.5rem", textTransform: "uppercase" }}>Best Free HTML Email Signature Generator Online</h1>
      <hr className="new1" />
      <p>
        Your signature is undoubtedly one of the most important parts of the emails you are sending off. It depicts your authenticity, as well as instills trust and confidence in the minds of the recipients. Hence, it goes without saying that a well-crafted email signature is indispensable for your business. You can generate a custom email signature with our simple and free email signature generator tool to create the best impression on your mail recipients. Our html email signature generator is compatible with all the available email clients. </p>
		
		<p> Check out the free email signature generator below and create a custom signature to attach with your emails. 
      </p>
    </div>
  );
}

export default About;
